export default "__VITE_ASSET__QZJVsmjQ__"